import { render } from "./SimuladorSolar.vue?vue&type=template&id=5678dfaf&scoped=true&ts=true"
import script from "./SimuladorSolar.vue?vue&type=script&lang=ts"
export * from "./SimuladorSolar.vue?vue&type=script&lang=ts"

import "./SimuladorSolar.vue?vue&type=style&index=0&id=5678dfaf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5678dfaf"]])

export default __exports__